import React from "react";
import { useDispatch } from "react-redux";
import { toggleCheckInStatus } from "slices/userSlice";
import { CustomSwitch } from "./Switch";
import toast from "react-hot-toast"; // ✅ Add this

const CheckInButton = ({ initialCheckedIn, role, internalInterpreter }) => {
  const [checkedIn, setCheckedIn] = React.useState(initialCheckedIn);
  console.log(initialCheckedIn, "checkedIn")
  const [loading, setLoading] = React.useState(false);
  const dispatch = useDispatch();
  console.log(initialCheckedIn, 'initialCheckedIn')

      React.useEffect(() => {
  setCheckedIn(initialCheckedIn);
}, [initialCheckedIn]);

  const handleToggleCheckIn = () => {
    if (loading) return; // prevent double clicks
    const newStatus = !checkedIn;

    // Instant UI feedback
    setCheckedIn(newStatus);
    setLoading(true);



    dispatch(
      toggleCheckInStatus((success, data) => {
        setLoading(false);

        if (success) {
          console.log(data , 'datatat')
          data?.data?.checked_in ?
          toast.success("Checked In successfully."):
          toast.success("Checked Out successfully.");
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          setCheckedIn(prev => !prev);

          const errorMsg =
            data?.message || "Failed to check-in / check-out. Please try again.";
          toast.error(errorMsg);
        }
      })
    );
  };

  if (role === "staff_interpreter" && internalInterpreter === 0) {
    return null;
  }

  return (

    <div className="d-flex align-items-center gap-3">
      <h2 className={`fw-bold d-none d-sm-block mb-0 ${checkedIn ? "text-success" : "text-danger"}`}>{checkedIn ? "Checked In" : "Checked Out"}</h2>
      <CustomSwitch
        labelText={checkedIn ? "Checked In" : "Checked Out"}
        checked={checkedIn}
        disabled={loading}
        handleChange={handleToggleCheckIn}
        className={`${checkedIn ? "switch-green" : "switch-red"}`}
      />
    </div>
  );
};

export default CheckInButton;
